@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.pointsOfIntrest
import com.narbase.letsgo.dto.core.KmmLong
class PointOfInterestDto(
    val id: KmmLong?,
    val lat: Double,
    val lng: Double,
    val address: String,
    val name: String,
    val nameFr: String?,
    val isActive: Boolean,
    val placeTypeId: KmmLong?,
    val blockL1Id: KmmLong?,
    val normalisedTerms: String?,
    val alternativeNames: String?
)

fun PointOfInterestDto.getFullAddress() = "$name, $address"